import { LineTagType } from '@/components/LineItem/LineItem'
import { Occupant, Pet1I, Pet2I, Vehicile2I, VehicileI } from '@/types/RentalApplication'

type Vehicle2Fields = keyof Vehicile2I
type VehicleFields = keyof VehicileI
type Pet1Fields = keyof Pet1I
type Pet2Fields = keyof Pet2I
type OccupantFields = keyof Occupant

export const vehicle1Data: { field: VehicleFields; label: string; tag?: LineTagType }[] = [
  { label: 'Type', field: 'vehicleType', tag: 'info' },
  { label: 'Make', field: 'vehicleMake' },
  { label: 'Model', field: 'vehicleModel' },
  { label: 'Year', field: 'vehicleYear' },
  { label: 'State', field: 'vehicleState' },
  { label: 'LP', field: 'vehicleLicensePlate' },
  { label: 'Selection', field: 'vehicleParkingSelection', tag: 'success' },
]

export const vehicle2Data: { field: Vehicle2Fields; label: string; tag?: LineTagType }[] = [
  { label: 'Type', field: 'vehicle2Type', tag: 'info' },
  { label: 'Make', field: 'vehicle2Make' },
  { label: 'Model', field: 'vehicle2Model' },
  { label: 'Year', field: 'vehicle2Year' },
  { label: 'State', field: 'vehicle2State' },
  { label: 'LP', field: 'vehicle2LicensePlate' },
  { label: 'Selection', field: 'vehicle2ParkingSelection', tag: 'success' },
]

export const pet1Data: { field: Pet1Fields; label: string; tag?: LineTagType }[] = [
  { label: 'Name', field: 'pet1Name' },
  { label: 'Type', field: 'pet1Type', tag: 'success' },
  { label: 'Age', field: 'pet1Age' },
  { label: 'Breed', field: 'pet1Breed' },
  { label: 'Color', field: 'pet1Color' },
  { label: 'Weight', field: 'pet1Weight' },
  { label: 'ESA', field: 'pet1ServiceAnimal', tag: 'info' },
]

export const pet2Data: { field: Pet2Fields; label: string; tag?: LineTagType }[] = [
  { label: 'Name', field: 'pet2Name' },
  { label: 'Type', field: 'pet2Type', tag: 'success' },
  { label: 'Age', field: 'pet2Age' },
  { label: 'Breed', field: 'pet2Breed' },
  { label: 'Color', field: 'pet2Color' },
  { label: 'Weight', field: 'pet2Weight' },
  { label: 'ESA', field: 'pet2ServiceAnimal', tag: 'info' },
]

export const occupantData: { field: OccupantFields; label: string; tag?: LineTagType }[] = [
  { label: 'Name', field: 'name' },
  { label: 'Email', field: 'email' },
  { label: 'Contact', field: 'phoneNumber' },
  { label: 'Birthday', field: 'dateOfBirth' },
]
